var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"navInner"},[_c('div',{staticClass:"backIcon",on:{"click":function($event){return _vm.clickBack()}}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }